import { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { UserContext } from '../contexts/User';
import { getMemberRoleLevel } from '../utils/permissions';
import { accountTypeLevel } from '../constants/accountTypes';
import { NotificationContext } from '../contexts/Notification';
import { TOUR_CHECK_EVENT } from '../components/GuidedTour/steps';

function useWorkspaces() {
  const history = useHistory();
  const { selectWorkspace, startTwoFactor } = useContext(UserContext);
  const { displayNotification } = useContext(NotificationContext);

  const handleWorkspaceSelection = async (workspace) => {
    // Check if workspace uses SAML authentication
    if (workspace.authentication === 'SAML') {
      // Redirect to SAML login for this workspace
      window.location.href = `/api/auth/saml/login/${workspace.id}`;
      return;
    }

    const res = await selectWorkspace(workspace.id, workspace.member.user);
    if (res.success) {
      // Get member level using the new utility function
      const memberLevel = getMemberRoleLevel(workspace.member);

      // eslint-disable-next-line no-nested-ternary
      const targetUrl = memberLevel >= accountTypeLevel['Workspace admin']
        ? 'dashboard'
        : memberLevel === accountTypeLevel['Team Leader']
          ? 'members/team-engagement' : 'pto/requests';
      if (res?.qrCode) {
        startTwoFactor({ qrCode: res.qrCode, twoFactorToken: res.twoFactorToken, redirect: targetUrl });
      } else if (res?.twoFactorToken) {
        startTwoFactor({ twoFactorToken: res.twoFactorToken, redirect: targetUrl });
      } else {
        history.push(`/${targetUrl}`);
        // Workspace is now active (token + member set). Let the guided tour check
        // this member's saved status and show itself if they haven't seen it.
        window.dispatchEvent(new CustomEvent(TOUR_CHECK_EVENT, { detail: { workspaceId: workspace.id } }));
      }
    } else {
      displayNotification({
        message: 'Sign in workspace failed.',
        severity: 'error',
        verticalAlign: 'top',
      });
    }
  };

  return { handleWorkspaceSelection };
}

export default useWorkspaces;
